import axios from 'axios'
import Cookies from 'js-cookie'
   
   const instance = axios.create({
     baseURL: 'https://member.management.biggerlens.cn:8081',
     headers: {
       'token': Cookies.get('token'), // 在这里设置token
       'Content-Type': 'application/json'
     }
   });
   
   export default instance;